import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'semantic-ui-react';

import { escribirMonto } from '../../utilidades';
import { Columna, DatosApoderado, FormasPago } from '../tipos';

const nombresFormasPago: Record<FormasPago, string> = {
    contado: 'Contado',
    tarjeta: 'Tarjeta',
    cheque: 'Cheque',
    pagare: 'Pagaré',
};

interface Props {
    columnaAOrdenar: Columna;
    direccionDelOrden: 'ascending' | 'descending';
    datos: ReadonlyArray<Readonly<DatosApoderado>>;
    alClickearCabecera(columna: Columna): void;
}

type FilaProps = DatosApoderado;

class Fila extends React.PureComponent<FilaProps> {
    public render() {
        const {
            apoderadoId,
            nombre,
            rut,
            pagare,
            contratos,
            formaPago,
            numeroCuotas,
            valorCuota,
            deudor,
            diaDePago,
        } = this.props;

        return (
            <Table.Row error={deudor}>
                <Table.Cell selectable>
                    <Link to={`/cobranzas/plan/${apoderadoId}`}>
                        <b>{nombre}</b>
                    </Link>
                </Table.Cell>

                <Table.Cell>{rut}</Table.Cell>
                <Table.Cell>{contratos.join(', ')}</Table.Cell>
                <Table.Cell>{pagare}</Table.Cell>
                <Table.Cell>{nombresFormasPago[formaPago]}</Table.Cell>
                <Table.Cell textAlign='center'>{numeroCuotas}</Table.Cell>
                <Table.Cell textAlign='right'>{escribirMonto(valorCuota)}</Table.Cell>
                <Table.Cell textAlign='center'>
                    {diaDePago !== undefined ? diaDePago : ''}
                </Table.Cell>
            </Table.Row>
        );
    }
}

const TablaApoderadosPlanesDePago: React.FunctionComponent<Props> = props => {
    const { datos, columnaAOrdenar, direccionDelOrden, alClickearCabecera } = props;

    const propsOrdenamiento = (columna: Columna) => ({
        sorted: columnaAOrdenar === columna ? direccionDelOrden : undefined,
        onClick: () => alClickearCabecera(columna),
    });

    return (
        <Table compact selectable sortable attached='bottom'>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell width='6' content='Nombre' {...propsOrdenamiento('nombre')} />

                    <Table.HeaderCell
                        width='2'
                        content='Rut/Pasaporte'
                        {...propsOrdenamiento('rut')}
                    />

                    <Table.HeaderCell
                        width='1'
                        content='Nº contrato'
                        {...propsOrdenamiento('contratos')}
                    />

                    <Table.HeaderCell
                        width='1'
                        content='Nº pagaré'
                        {...propsOrdenamiento('pagare')}
                    />

                    <Table.HeaderCell
                        width='2'
                        content='Forma de pago'
                        {...propsOrdenamiento('formaPago')}
                    />

                    <Table.HeaderCell
                        width='1'
                        content='Nº cuotas'
                        {...propsOrdenamiento('numeroCuotas')}
                    />

                    <Table.HeaderCell
                        width='1'
                        content='Valor cuota'
                        {...propsOrdenamiento('valorCuota')}
                    />

                    <Table.HeaderCell
                        width='2'
                        content='Día de pago'
                        {...propsOrdenamiento('diaDePago')}
                    />
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {datos.map(fila => (
                    <Fila key={fila.apoderadoId} {...fila} />
                ))}
            </Table.Body>
        </Table>
    );
};

export default TablaApoderadosPlanesDePago;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/BuscarApoderado/componentes/TablaApoderadosPlanesDePago.tsx